import * as React from 'react';

import styled from 'styled-components';

interface DashboardContainerProps {
  className?: string;
  children?: React.ReactNode;
}

export const DashboardContainer: React.FC<DashboardContainerProps> = ({
  className,
  children,
}) => {
  return <section className={className}>{children}</section>;
};

export default styled(DashboardContainer)`
  max-width: none;
  padding: 24px 24px 55px;

  @media ${({ theme }) => theme.device.tablet} {
    padding: 55px;
  }

  @media ${({ theme }) => theme.device.laptop} {
    padding: 90px 90px 110px;
  }

  @media ${({ theme }) => theme.device.laptopXL} {
    padding: 90px 180px 110px;
  }

  @media ${({ theme }) => theme.device.desktopL} {
    padding: 130px 320px;
  }
`;
